/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';
import type { TileTemplateDTO } from './TileTemplateDTO';
import {
    TileTemplateDTOFromJSON,
    TileTemplateDTOFromJSONTyped,
    TileTemplateDTOToJSON,
} from './TileTemplateDTO';

/**
 * 
 * @export
 * @interface TileTemplatePageDTO
 */
export interface TileTemplatePageDTO {
    /**
     * 
     * @type {Array<TileTemplateDTO>}
     * @memberof TileTemplatePageDTO
     */
    content?: Array<TileTemplateDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof TileTemplatePageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TileTemplatePageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TileTemplatePageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof TileTemplatePageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof TileTemplatePageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof TileTemplatePageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof TileTemplatePageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof TileTemplatePageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof TileTemplatePageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the TileTemplatePageDTO interface.
 */
export function instanceOfTileTemplatePageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TileTemplatePageDTOFromJSON(json: any): TileTemplatePageDTO {
    return TileTemplatePageDTOFromJSONTyped(json, false);
}

export function TileTemplatePageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TileTemplatePageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(TileTemplateDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function TileTemplatePageDTOToJSON(value?: TileTemplatePageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(TileTemplateDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

